/* eslint-disable react-hooks/exhaustive-deps */
import React, {useContext, useEffect, useState, useMemo } from 'react';
import { useHistory } from 'react-router-dom';

import { makeStyles, 
    Theme, 
    TextField, 
    Dialog, 
    DialogActions, 
    DialogContent, 
    DialogContentText, 
    DialogTitle,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Checkbox,
    InputAdornment,
    Grid } from '@material-ui/core';

import { addYears, isBefore, isAfter, parse, format, addMonths } from 'date-fns';

import { AppContext } from '../stores/AppStore';
import { UserContext } from '../stores/UserStore';
import { SecurityContext } from '../stores/SecurityStore';

import LoadingOverlay from '../components/common/LoadingOverlay';

import PageContainer from '../components/layout/PageContainer';
import PageToolbar from '../components/layout/PageToolbar';
import PageBody from '../components/layout/PageBody';

import DataTable from '../components/table/DataTable';
import Button from '../components/common/Button';

import AddIcon from '@material-ui/icons/AddBox';
import DeleteIcon from '@material-ui/icons/Delete';
import FileCopy from '@material-ui/icons/FileCopy';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import ToggleOffIcon from '@material-ui/icons/ToggleOff';
import ToggleOnIcon from '@material-ui/icons/ToggleOn';
import RefreshIcon from '@material-ui/icons/Refresh';

import { purple } from '@material-ui/core/colors';


const useStyles = makeStyles((theme: Theme) => ({
    root: {
        // padding: theme.spacing(2),
    },
    dialogRoot: {
        '& .MuiPaper-root': {
            backgroundColor: theme.palette.text.primary,
        }
    },
    dialogTitle: {
        padding: '10px 24px 0px 24px',
        color: '#00000094'
    },
    dialogContent: {
        minHeight: '50vh',
        color: '#00000094',
        // padding: '20px',
        // display: 'flex',
        // alignItems: 'flex-start',
        // justifyContent: 'flex-start',
        // flexDirection: 'column'
        '& .MuiPaper-elevation1': {
            boxShadow: 'none',
            // '& .MuiToolbar-root': {
            //     backgroundColor: 'blue'
            // }, 
        }
    },
    textField: {
        width:  'calc(100% - 20px)',
        margin: theme.spacing(3,0,0,0),
        fontSize: 12,
        '& .MuiFormLabel-root': {
            color: '#666666'
        },
        '& .MuiInput-root': {
            // color: theme.palette.primary.main,
            color: '#000000',
            '& .MuiInputBase-input': {
                paddingLeft: '10px',
                backgroundColor: '#FFFFFF',
                height: '1.8em',
                borderRadius: '4px',
                boxShadow: 'inset 0 1px 3px 0 rgba(0,0,0,0.14)'
            },
            '& .MuiSelect-select.MuiSelect-select': {
                paddingTop: '10px',
                paddingBottom: '0px'
            },
            '& .Mui-disabled': {
                opacity: 0.5
            }                
        }
    },
    textArea: {
        margin: theme.spacing(3,0,0,0),
        fontSize: 12,
        '& .MuiFormLabel-root': {
            color: '#666666'
        },
        '& .MuiInput-root': {
            // color: theme.palette.primary.main,
            color: '#000000',
            '& .MuiInputBase-input': {
                paddingLeft: '10px',
                backgroundColor: '#FFFFFF',
                borderRadius: '4px',
            },
            '& .Mui-disabled': {
                opacity: 0.5
            }                
        }
    },    
    list: {
        width: 'calc(100% - 20px)',
        backgroundColor: theme.palette.text.primary,
    },         
    listItem: {
        margin: '0px',
        padding: '0px'
    },
    checkbox: {
        margin: '0px',
        padding: '0px'
    },
    listItemText: {
        margin: '0px',
        padding: '0px'
    },
    row: {
        display: 'flex', 
        flexDirection: 'row'
    },
    detailGrid: {
        margin: '0 20px',
        fontSize: 13
    },
    dialogActions: {
        '& .MuiButton-contained.Mui-disabled': {
            color: theme.palette.grey[300],
            border: '1px solid' 
        }
    },
    buttonPurple: {
        color: theme.palette.getContrastText(purple[500]),
        backgroundColor: purple[500],
        '&:hover': {
            backgroundColor: purple[700],
        },
    },
}));


const Services = () => {
    const history = useHistory();    
    const classes = useStyles();
    const { applicationSearchText, setApplicationSearchText, showSuccessMessage, showErrorMessage } = useContext(AppContext);
    const { currentUser } = useContext(UserContext);

    const { servicesData, servicesManagement } = useContext(SecurityContext)
    const [isLoading, setLoading] = useState(true);
    const [currentRecord, setCurrentRecord] = useState(null);
    const [listProfiles, setListProfiles] = useState([]);
    const [action, setAction] = useState(null);

    useEffect(() =>  {
        if (applicationSearchText) {
            setApplicationSearchText('');
            history.push('/search/users/'+applicationSearchText);
        }
    }, [applicationSearchText]);


    useEffect(() =>  {
        init();
    }, []);

    const init = () => {
        setLoading(true);        
        servicesManagement({init: true}).catch(errorMessage => {
            showErrorMessage(errorMessage);
        }).finally(() => {
            setLoading(false);            
        });    
    }
            
    const handleClickNew = () => {
        const today = parse(format(new Date(), 'yyyy-MM-dd'), 'yyyy-MM-dd', new Date()); 
        const sixMonths = addMonths(today, 6);
        const record = {profiles: [], expirationDate: sixMonths.getTime()};
        setAction('New');
        setCurrentRecord(record);
    };

    useEffect(() =>  {
        if (currentRecord) {
            if (action === 'Permission' || action === 'Permission+New') {
                const list = JSON.parse(JSON.stringify(servicesData.profilesData));
                const listProfiles = list.map(x => {
                    const profile = {
                    ...x,
                    disabled: true
                    }
                    const profileCkeck = servicesData.checkData.find(x => x.id === profile.id);
                    if (profileCkeck && profileCkeck.isOwner) {
                    profile.disabled = false;
                    }
                    return profile;
                }).filter(x => !x.disabled);
                    
                const listProfilesSelected = listProfiles.filter(x => currentRecord.profiles.map(y => y.id).includes(x.id));
                for (const profileSelected of listProfilesSelected) {
                    const profile = listProfiles.find(x => x.id === profileSelected.id);
                    if (profile) {
                        profile.checked = true;
                    }
                }
                setListProfiles(listProfiles);   
            }
        }
    }, [currentRecord, action]);

    useEffect(() =>  {
        if (currentRecord && (action === 'Saved')) {
            const record = servicesData.tableData.find(x => x.token != null);
            // record.token = btoa(JSON.stringify({"apiKey": record.apiKey, "secretKey": record.secretKey}));    
            // record.token = 'svc.'+record.id+'.'+record.secretKey;
            setCurrentRecord(record);
            setAction('Credentials');
        }
    }, [currentRecord, action, servicesData.tableData]);
        
    const handleClickDelete = (event, rowData) => {
        setAction('Delete');
        setCurrentRecord(rowData);
    };    

    const handleClickClose = () => {
        setAction(null);
        setCurrentRecord(null);
        setListProfiles([]);
    };

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.preventDefault();
        const record = {...currentRecord};
        if (event.target.name === 'expirationDate') {
            record.expirationDateError = null;
            //yyyy-MM-dd
            const today = parse(format(new Date(), 'yyyy-MM-dd'), 'yyyy-MM-dd', new Date()); 
            const oneYear = addYears(today, 1);
            const expirationDate = parse(event.target.value, 'yyyy-MM-dd', new Date()); 
            if (isBefore(expirationDate, today) || isAfter(expirationDate, oneYear)) {
                record.expirationDateError = 'Expiration date must be from 0 day to 1 year!';
            }
            record.expirationDate = expirationDate.getTime();
        } else {
            record[event.target.name] = event.target.value;
        }
        setCurrentRecord(record);
    };        

    const handleToggleChange = (event, rowData) => {
        const record = {...rowData};
        setLoading(true);
        const inactive = record.inactive === undefined ? true : !record.inactive;            
        const text = inactive ? 'inactivated' : 'activated' 
        servicesManagement({ status: {id: record.id,  inactive: inactive }}).then(() => {
            showSuccessMessage('Service '+text+' success!');
        }).catch(errorMessage => {
            showErrorMessage(errorMessage);
        }).finally(() => {
            setAction(null);
            setCurrentRecord(null);
            setLoading(false);            
        });
    };        

    const doClickDelete = () => {
        setLoading(true);            
        servicesManagement({ delete: currentRecord.id }).then(() => {
            showSuccessMessage('Service delete success!');
        }).catch(errorMessage => {
            showErrorMessage(errorMessage);
        }).finally(() => {
            setAction(null);
            setCurrentRecord(null);
            setLoading(false);            
        });
    };      

    const doClickSave = () => {
        setAction('Permission+New');
    };      

    const doClickSavePermission = () => {
        setLoading(true);        

        currentRecord.profiles = listProfiles.filter(x => x.checked).map(x => x.id);
        if (currentRecord.foreignProfiles) {
            currentRecord.profiles = currentRecord.profiles.concat(currentRecord.foreignProfiles);
            delete currentRecord.foreignProfiles;
        }

        const params = action === 'Permission+New' ?  { save: currentRecord } : { permission: {id: currentRecord.id, profiles: currentRecord.profiles, groups: currentRecord.groups} };

        servicesManagement(params).then(() => {
            showSuccessMessage('Service saved success!');
        }).catch(errorMessage => {
            showErrorMessage(errorMessage);
        }).finally(() => {
            if (action === 'Permission+New') {
                setAction('Saved');
            } else {
                setAction(null);
                setCurrentRecord(null);
                setListProfiles([]);
            }
            setLoading(false);                
        });           

    };      

    const handleCopyToClipboardClick = (field: string) => async () => {
        const record = {...currentRecord};
        record.copyField = field;
        await navigator.clipboard.writeText(currentRecord[record.copyField]);
        setCurrentRecord(record);
    };
    
    const handleCheckPermissions = (rowData: any) => () => {
        const list = JSON.parse(JSON.stringify(listProfiles));
        const role = list.find(x => x.id === rowData.id);
        role.checked = !role.checked;
        setListProfiles(list);
    };           

    const renderTableData = useMemo(() => <DataTable
        isLoading={action === null && isLoading}
        columns={[
            { title: 'Name', field: 'name' },
            { title: 'API Key', field: 'id' },
            { title: 'Expiration Date', field: 'expirationDate', render: rowData => <span>{rowData.expirationDate ? new Date(rowData.expirationDate).toLocaleDateString() + ' ' : ''}</span> }

        ]}
        data={JSON.parse(JSON.stringify(servicesData.tableData))}        
        actions={[
            {
                icon: () => <DeleteIcon color="error" />,
                tooltip: 'Delete Service',
                onClick: handleClickDelete,
                hidden: !currentUser.roles.SERVICE.REMOVE_RECORD
            },
            {
                icon: () => <RefreshIcon color="primary" />,
                tooltip: 'Refresh',
                onClick: (event) => init(),
                isFreeAction: true
            },
            rowData => (
                {
                    icon: () => rowData.inactive ? <ToggleOffIcon color="action" /> : <ToggleOnIcon color="primary" />,
                    tooltip: rowData.inactive ? 'Service Inactive' : 'Service Active',
                    onClick: handleToggleChange,
                    hidden: !currentUser.roles.SERVICE.SAVE_RECORD
                }
            )
        ]}               
        detailPanel={rowData => {
            return (
                <Grid container className={classes.detailGrid} spacing={1}>
                    <Grid item xs={12}>
                        <b>Profiles:</b> {rowData.profileName}
                    </Grid>
                </Grid>
            )
        }}/>, [servicesData, isLoading]);
        
        const renderListProfiles = useMemo(() => <List className={classes.list} dense component="div" role="list" >
            {listProfiles.map((profile) => {
                const labelId = `permissions-list-label-${profile.id}`;
                return (
                    <ListItem key={profile.id} className={classes.listItem} role={undefined} dense button onClick={handleCheckPermissions(profile)}>
                        <ListItemIcon>
                            <Checkbox
                                className={classes.checkbox}
                                edge="start"
                                checked={profile.checked ? profile.checked : false}
                                tabIndex={-1}
                                inputProps={{ 'aria-labelledby': labelId }}
                            />
                        </ListItemIcon>
                        <ListItemText id={labelId} className={classes.listItemText} primary={profile.name} />
                    </ListItem>
                );
            
            })}
        </List>, [listProfiles]);

    return (
        <PageContainer className={classes.root}>
            <PageToolbar title="Service Account Management" backButton={true}>
                { currentUser.roles.SERVICE.SAVE_RECORD && <>
                    <Button variant="contained" color="primary" size="small" startIcon={<AddIcon />} onClick={handleClickNew} >
                        New Service
                    </Button>
                </>}
            </PageToolbar>
            <PageBody>
            { servicesData.tableData && renderTableData }
            </PageBody>
            <Dialog
                className={classes.dialogRoot}
                disableBackdropClick
                disableEscapeKeyDown            
                fullWidth
                maxWidth="sm"
                open={action === 'New'}
                aria-labelledby="save-dialog">
                <DialogTitle className={classes.dialogTitle} id="save-dialog">{action} Service</DialogTitle>
                <DialogContent dividers={false} className={classes.dialogContent} style={{minHeight: '30vh'}}>
                    { currentRecord && <>
                        <div className={classes.row}>
                            <TextField
                                label="Name:"
                                required
                                type="text"
                                placeholder="Name"
                                id="name"
                                name="name"
                                className={classes.textField}
                                error={currentRecord.name !== undefined && !currentRecord.name}
                                value={currentRecord.name}
                                onChange={handleInputChange}                            
                                fullWidth
                                margin="dense"
                                InputLabelProps={{shrink: true}}
                                />
                        </div>
                        <div className={classes.row}>
                            <TextField
                                label="Expiration Date:"
                                required
                                type="date"
                                placeholder="Expiration Date"
                                id="expirationDate"
                                name="expirationDate"
                                className={classes.textField}
                                error={currentRecord.expirationDate !== undefined && (!currentRecord.expirationDate || currentRecord.expirationDateError)}
                                helperText={currentRecord.expirationDateError}
                                value={format(new Date(currentRecord.expirationDate), 'yyyy-MM-dd')}
                                onChange={handleInputChange}                            
                                fullWidth
                                margin="dense"
                                InputLabelProps={{shrink: true}}
                                />
                        </div>
                    </> }
                </DialogContent>
                <DialogActions className={classes.dialogActions} >
                    <Button variant="contained" color="secondary" startIcon={<CloseIcon />} onClick={handleClickClose}>
                        Close
                    </Button>
                    <Button disabled={currentRecord && (!currentRecord.name || !currentRecord.expirationDate || currentRecord.expirationDateError)} variant="contained" color="primary" startIcon={<SaveIcon />} onClick={doClickSave} >
                        Save
                    </Button>
                </DialogActions>
                <LoadingOverlay open={isLoading} />
            </Dialog>
            <Dialog
                className={classes.dialogRoot}
                disableBackdropClick
                disableEscapeKeyDown            
                fullWidth
                maxWidth="sm"
                open={action === 'Delete'}
                aria-labelledby="delete-dialog">
                <DialogTitle className={classes.dialogTitle} id="delete-dialog" >{action} Service</DialogTitle>
                <DialogContent dividers={false}>
                    <DialogContentText>
                        Do you want delete user "{currentRecord && currentRecord.name}"? 
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="secondary" startIcon={<CloseIcon />} onClick={handleClickClose}>
                        Close
                    </Button>
                    <Button variant="contained" color="primary" startIcon={<DeleteIcon />} onClick={doClickDelete} >
                        Delete
                    </Button>
                </DialogActions>
                <LoadingOverlay open={isLoading} />
            </Dialog>
            <Dialog
                className={classes.dialogRoot}
                disableBackdropClick
                disableEscapeKeyDown            
                fullWidth
                maxWidth="md"
                open={action === 'Permission' || action === 'Permission+New'}
                aria-labelledby="permissions-dialog">
                <DialogTitle className={classes.dialogTitle} id="permissions-dialog">Edit Permissions: {currentRecord && currentRecord.name}</DialogTitle>
                <DialogContent dividers={false} className={classes.dialogContent}>
                    { currentRecord && renderListProfiles }
                </DialogContent>
                <DialogActions className={classes.dialogActions} >
                    <Button variant="contained" color="secondary" startIcon={<CloseIcon />} onClick={handleClickClose}>
                        Close
                    </Button>
                    <Button disabled={listProfiles && listProfiles.filter(x => x.checked).length === 0} variant="contained" color="primary" startIcon={<SaveIcon />} onClick={doClickSavePermission} >
                        Save
                    </Button>
                </DialogActions>
                <LoadingOverlay open={isLoading} />
            </Dialog>

            <Dialog
                className={classes.dialogRoot}
                disableBackdropClick
                disableEscapeKeyDown            
                fullWidth
                maxWidth="md"
                open={action === 'Credentials'}
                aria-labelledby="credentials-dialog">
                <DialogTitle className={classes.dialogTitle} id="credentials-dialog">Service Token: {currentRecord && currentRecord.name}</DialogTitle>
                <DialogContent dividers={false} className={classes.dialogContent} style={{minHeight: '40vh'}}>
                    { currentRecord && <TextField
                            id="token"
                            name="token"
                            multiline
                            rows={12}
                            className={classes.textArea}
                            value={currentRecord.token}
                            fullWidth
                            helperText={currentRecord.copyField && currentRecord.copyField === 'token' ?  'Copied!' : 'Use this token in the Authorization header parameter of the request to call secure endpoints.'}
                            InputProps={{
                                readOnly: true,
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <FileCopy color="primary" onClick={handleCopyToClipboardClick('token')} />
                                    </InputAdornment>
                                    )                                    
                            }}                            
                        /> }
                </DialogContent>
                <DialogActions className={classes.dialogActions} >
                    <Button variant="contained" color="secondary" startIcon={<CloseIcon />} onClick={handleClickClose}>
                        Close
                    </Button>
                </DialogActions>
                <LoadingOverlay open={isLoading} />
            </Dialog>

        </PageContainer>
    );
};

export default Services;
